// What only a gym / fitness coach account has: membership plans, members, trainers (solo or team).
import Plans from "../../pages/Gym/Plans.js";
import Members from "../../pages/Gym/Members.js";
import Instructors from "../../pages/Gym/Instructors.js";
import SiteContent from "../../pages/Gym/SiteContent.js";
import GymOnboarding from "../../pages/Gym/GymOnboarding.js";
import GymCalendar from "../../pages/Gym/GymCalendar.js";
import LibraryManager from "../../pages/Gym/LibraryManager.js";

import { gymMenu, gymMessages } from "./messages";

const gym = {
  id: "gym",

  messages: gymMessages,

  Onboarding: GymOnboarding,

  routes: [
    { path: "/plans", exact: true, module: "MEMBERSHIPS", component: Plans },
    { path: "/members", exact: true, module: "MEMBERSHIPS", component: Members },
    { path: "/trainers", exact: true, module: "INSTRUCTORS", component: Instructors },
    { path: "/site-content", exact: true, module: "MEMBERSHIPS", component: SiteContent },
    { path: "/calendar", exact: true, module: "CALENDAR", component: GymCalendar },
    { path: "/library", exact: true, module: "LIBRARY", component: LibraryManager },
  ],

  menu: gymMenu,
};

export default gym;
